import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogImage, ogType = 'website', schema }: SEOProps) {
  const baseUrl = 'https://adultvideoguide.cn';
  const fullTitle = `${title} - 成人短视频指南`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (ogImage) {
      setMeta('twitter:image', ogImage);
    }

    let canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalUrl) {
      if (!canonicalEl) {
        canonicalEl = document.createElement('link');
        canonicalEl.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute('href', `${baseUrl}${canonicalUrl}`);
    } else if (canonicalEl) {
      canonicalEl.remove();
    }

    let schemaEl = document.querySelector('script[data-schema="seo"]');
    if (schemaEl) schemaEl.remove();
    if (schema) {
      schemaEl = document.createElement('script');
      schemaEl.setAttribute('type', 'application/ld+json');
      schemaEl.setAttribute('data-schema', 'seo');
      schemaEl.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaEl);
    }
  }, [title, description, keywords, canonicalUrl, ogImage, ogType, schema, fullTitle, baseUrl]);

  return null;
}